import { useQueryClient } from '@tanstack/react-query';
import { listQueryKeys } from 'constants/queryKey';
import { updateArtistsFromArtistResponse } from 'middleware/music-product-digital/updateArtistsFromArtistResponse';
import { useStoreState } from 'providers/StoreStateContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { IArtistResponse } from 'services/artists/types';
import { getLastPathname } from 'utils/navbar/getParentPathname';

export const useArtistGoBack = () => {
  const { trackForm, setForm, musicProductDigitalForm, clearForm, clearForms } = useStoreState();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { pathname } = useLocation();

  const onGoBack = async (artistId?: string, artist?: IArtistResponse) => {
    if (artist) {
      await queryClient.invalidateQueries({
        queryKey: [listQueryKeys.artistsLightList],
      });
      clearForm('artistForm');
    }

    const artistSearchParams = artist ? `?artistId=${artist.id}` : '';

    if (trackForm) {
      if (artist) {
        setForm('trackForm', {
          ...trackForm,
          artists: updateArtistsFromArtistResponse(artist, trackForm.artists),
        });
      }

      return navigate(
        `/track/${trackForm.id.length ? `edit/${trackForm.id}` : 'create'}/artists${artistSearchParams}`,
        {
          replace: true,
        },
      );
    }

    if (musicProductDigitalForm) {
      if (artist) {
        setForm('musicProductDigitalForm', {
          ...musicProductDigitalForm,
          artists: updateArtistsFromArtistResponse(artist, musicProductDigitalForm.artists),
        });
      }
      return navigate(
        `/music-product-digital/${musicProductDigitalForm.id.length ? `edit/${musicProductDigitalForm.id}` : 'create'}/artists${artistSearchParams}`,
        { replace: true },
      );
    }

    navigate(artistId ? `/artist/${artistId}/${getLastPathname(pathname)}` : '/artist', {
      replace: true,
    });
    clearForms();
  };

  return { onGoBack };
};
